module.exports = __webpack_public_path__ + "media/images/user/lp/step/step1-c6b527a2dfed5340f6e8561c225f532b.png";